import { MessageBarType } from "@fluentui/react";
import api from "../../api/index";

import { ROUTES } from "../../config/routes";
import { APIConfig } from "../../utils/apiUtils";
import { hideNotification, showNotification } from "./notification";
import { homeActions } from "../reducers/homeSlice";
import { getErrorMessage } from "./errorHandler";
import { showDialog } from "../reducers/dialogSlice";

const rootUrl = process.env.REACT_APP_API_ROOT_URL;

export const getHomeInfraCount = () => {
  return async (dispatch: any) => {
    dispatch(
      homeActions.setLoading({
        sourceAction: ROUTES["home"].title,
        value: true,
      })
    );
    const URL = APIConfig.getHomeInfraCountView();

    try {
      const response = await api.get(`${rootUrl}/${URL}`);
      const responseData: IResponseConfig | undefined = response.data;

      if (responseData && responseData.isSuccess) {
        let homeData: IHomeData | null = responseData.data;
        dispatch(
          homeActions.replaceInfraCountData({
            countData: homeData?.infraCount || null,
          })
        );
      } else {
        showNotification(
          dispatch,
          true,
          MessageBarType.error,
          responseData?.message && Array.isArray(responseData?.message) && responseData?.message.length > 0
            ? `Problem in fetching home infra count data. Please see the following message for more details: ${responseData?.message.join(", ")}`
            : "Problem occurred while fetching home infra count data. Please try again after some time or contact the dev support team.",
          ROUTES["home"].url
        );
      }
    } catch (error) {
      const message = getErrorMessage(error, "home", "fetch");
      dispatch(showDialog({
        message,
        confirmAction: "RELOAD_PAGE",
        visible: true
      }));

    } finally {
      dispatch(
        homeActions.setLoading({
          sourceAction: "",
          value: false,
        })
      );
      setTimeout(() => {
        hideNotification(dispatch, 5000);
      });
    }
  };
};

export const getHomeSGNamesList = () => {
  return async (dispatch: any) => {
    dispatch(
      homeActions.setLoading({
        sourceAction: ROUTES["home"].title,
        value: true,
      })
    );
    const URL = APIConfig.getHomeSGNames();

    try {
      const response = await api.get(`${rootUrl}/${URL}`);
      const responseData: IResponseConfig | undefined = response.data;

      if (responseData && responseData.isSuccess) {
        let homeData: IHomeData | null = responseData.data;
        dispatch(
          homeActions.replaceSGNameData({
            sgNames: homeData?.sgName || "",
          })
        );
      } else {
        showNotification(
          dispatch,
          true,
          MessageBarType.error,
          responseData?.message && Array.isArray(responseData?.message) && responseData?.message.length > 0
            ? `Problem in fetching security group names. Please see the following message for more details: ${responseData?.message.join(", ")}`
            : "Problem occurred while fetching security group names. Please try again after some time or contact the dev support team.",
          ROUTES["home"].url
        );
      }
    } catch (error) {
      const message = getErrorMessage(error, "home", "fetch");
      dispatch(showDialog({
        message,
        confirmAction: "RELOAD_PAGE",
        visible: true
      }));
    } finally {
      dispatch(
        homeActions.setLoading({
          sourceAction: "",
          value: false,
        })
      );
      setTimeout(() => {
        hideNotification(dispatch, 5000);
      });
    }
  };
}
